export default {
  init() {
    this.scrollToSection();
  },

  scrollToSection() {
    const scrollBtn = document.querySelector('.product-hero__scroll');
    if (!scrollBtn) return;

    scrollBtn.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById('product-content').scrollIntoView({
        behavior: 'smooth',
      });
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js